import {LOCALE_ID, NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";

import {AppRoutingModule} from "./app-routing.module";
import {AppComponent} from "./app.component";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {HeaderMenuComponent} from "./core/header-menu/header-menu.component";
import {AlertComponent} from "./shared/alert/alert.component";
import {SidebarComponent} from "./core/sidebar/sidebar.component";
import {DatePipe, NgOptimizedImage} from "@angular/common";
import {ErDashboardComponent} from "./features/error-report/er-dashboard/er-dashboard.component";
import {KdMalfunctionComponent} from "./features/knowledge-database/kd-malfunction/kd-malfunction.component";
import {KdSolutionComponent} from "./features/knowledge-database/kd-solution/kd-solution.component";
import {KdWorkplaceComponent} from "./features/knowledge-database/kd-workplace/kd-workplace.component";
import {DashboardComponent} from "./features/dashboard/dashboard.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ReportComponent} from "./features/report/report.component";
import {WorkplacesComponent} from "./features/workplaces/workplaces.component";
import {NgChartsModule} from "ng2-charts";
import {MatListModule} from "@angular/material/list";
import {MatDivider, MatDividerModule} from "@angular/material/divider";
import {CookieService} from "ngx-cookie-service";

// Import the German locale data
import localeDe from "@angular/common/locales/de";
import {registerLocaleData} from "@angular/common";
import {MatExpansionModule} from "@angular/material/expansion";
import {ConfirmationDialogComponent} from "./shared/confirmation-dialog/confirmation-dialog.component";
import {MatButtonModule} from "@angular/material/button";
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import {MatTableModule} from "@angular/material/table";
import {WorkplaceSelectionComponent} from "./features/workplace-selection/workplace-selection.component";
import {FormsModule} from "@angular/forms";
import {ActiveWorkplaceComponent} from "./core/active-workplace/active-workplace.component";
import {ModalComponent} from "./shared/components/modal/modal.component";
import {AdminModule} from "./features/admin/admin.module";
import {NavLinkComponent} from "./core/sidebar/components/nav-link/nav-link.component";
import {EditorComponent} from "./shared/components/editor/editor.component";
import {SafeHtmlPipe} from "./core/pipes/safe-html.pipe";
import {StopPropagationDirective} from "./directives/stop-propagation.directive";
import {WorkplaceFilterPipe} from "./core/pipes/workplace-filter.pipe";
import {EditorModalComponent} from "./shared/components/modal/editor-modal/editor-modal.component";
import {
  KdWorkplaceSelectionComponent
} from "./features/knowledge-database/kd-workplace-selection/kd-workplace-selection.component";
import {MediaModalComponent} from "./shared/components/modal/media-modal/media-modal.component";
import {ItemFormModalComponent} from "./shared/components/modal/item-form-modal/item-form-modal.component";
import {InProgressModalComponent} from "./shared/components/modal/in-progress-modal/in-progress-modal.component";
import {DashboardButtonComponent} from "./features/dashboard/components/dashboard-button/dashboard-button.component";
import {EscalationComponent} from "./features/escalation/escalation.component";
import {ReportTableComponent} from "./features/dashboard/components/report-table/report-table.component";
import {
  EditMediaItemModalComponent
} from "./shared/components/modal/edit-media-item-modal/edit-media-item-modal.component";
import {WorkplaceCardComponent} from "./features/workplaces/components/workplace-card/workplace-card.component";
import {WorkplaceReportComponent} from "./features/workplace-report/workplace-report.component";
import {SearchFilterBarComponent} from "./shared/components/search-filter-bar/search-filter-bar.component";
import {PaginatorComponent} from "./shared/components/paginator/paginator.component";
import {FilterInterfaceComponent} from "./shared/components/filter-interface/filter-interface.component";
import {RemoveHtmlAndTruncatePipe} from './core/pipes/remove-html-and-truncate.pipe';
import {EscalationModalComponent} from "./shared/components/modal/escalation-modal/escalation-modal.component";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {ReportCardComponent} from "./shared/components/report-card/report-card.component";
import {KdSearchResultsComponent} from "./features/knowledge-database/kd-search-results/search-results.component";
import {PieChartComponent} from './shared/components/charts/pie-chart/pie-chart.component';

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    AppComponent,
    AlertComponent,
    SidebarComponent,
    ErDashboardComponent,
    DashboardComponent,
    WorkplaceSelectionComponent,
    ActiveWorkplaceComponent,
    NavLinkComponent,
    WorkplaceFilterPipe,
  ],
  bootstrap: [AppComponent],
  imports: [BrowserModule,
    AppRoutingModule,
    NgbModule,
    HeaderMenuComponent,
    NgOptimizedImage,
    KdMalfunctionComponent,
    KdSolutionComponent,
    KdWorkplaceComponent,
    KdWorkplaceSelectionComponent,
    ReportComponent,
    BrowserAnimationsModule,
    NgChartsModule,
    MatExpansionModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatTableModule,
    MatSnackBarModule,
    FormsModule,
    MatListModule,
    MatDividerModule,
    ModalComponent,
    EditorModalComponent,
    MediaModalComponent,
    ItemFormModalComponent,
    AdminModule,
    EditorComponent,
    SafeHtmlPipe,
    StopPropagationDirective,
    InProgressModalComponent,
    DashboardButtonComponent,
    EscalationComponent,
    ReportTableComponent,
    EditMediaItemModalComponent,
    WorkplaceCardComponent,
    WorkplaceReportComponent,
    SearchFilterBarComponent,
    PaginatorComponent,
    FilterInterfaceComponent,
    WorkplacesComponent,
    RemoveHtmlAndTruncatePipe,
    EscalationModalComponent,
    ReportCardComponent,
    KdSearchResultsComponent,
    PieChartComponent,
    ConfirmationDialogComponent,

  ],
  providers: [CookieService, DatePipe, {
    provide: LOCALE_ID,
    useValue: 'de'
  }, provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule {
}
